import types from "actions/actionTypes";

const featuresReducer = (state = [], action) => {
  if (action.type !== types.SET_APP_FEATURES) return state;

  return action.payload;
};

export default featuresReducer;
